import React from 'react';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { ReactComponent as SvgLifts } from 'public/assets/icons/lifts.svg';
import { IResortPageSnowInfo, IResortTerrainDetail } from 'api/resort/types';
import { useDistanceFormatter } from 'i18n/unitFormat';
import { ReactComponent as SvgRuns } from 'public/assets/icons/runs.svg';
import { ReactComponent as SvgOpenTotal } from '../../../../public/assets/icons/nordic-open.svg';
import { ReactComponent as SvgSkateGroomed } from '../../../../public/assets/icons/nordic-skate.svg';
import { ReactComponent as SvgTrackset } from '../../../../public/assets/icons/nordic-trackset.svg';
import { MetricListItem } from '../MetricListItem';
import { useBuildTerrainIcons } from '../Terrain/useBuildTerrainIcons';
import styles from './styles.module.scss';
import { ReactComponent as SvgAcres } from '../../../../public/assets/icons/acres.svg';

export const LiftTerrainStatus = ({ fullResort, resortCountry }: { fullResort: IResortPageSnowInfo, resortCountry: string | undefined }) => {
  const { t } = useOTSTranslation('common');
  const unitT = useDistanceFormatter('kmOrMile');

  const liftsOpen = fullResort.lifts?.open ? `${fullResort.lifts?.open}/${fullResort.lifts?.total} ${t('resort.skiReport.openFacilities')}` : null;
  const acresOpen = fullResort.terrain?.acres?.open ? `${fullResort.terrain?.acres.open} ${t('resort.skiReport.acresOpen')}` : null;
  const kmsOpen = fullResort.terrain?.km?.open ? `${fullResort.terrain?.km.open} ${t('resort.skiReport.kmPercentOpen')}` : null;
  const runsOpen = fullResort.runs?.open ? `${fullResort.runs?.open}/${fullResort.runs?.total} ${t('resort.skiReport.openFacilities')}` : null;

  const terrainDetails: IResortTerrainDetail[] | null = useBuildTerrainIcons({
    data: {
      advanced: fullResort.terrain?.runsAdvanced,
      beginner: fullResort.terrain?.runsBeginner,
      expert: fullResort.terrain?.runsExpert,
      intermediate: fullResort.terrain?.runsIntermediate,
      canReturnBySki: fullResort.terrain?.canReturnBySki,
      runs: fullResort.terrain?.runs,
    },
    resortCountry,
  });

  return (
    <div className={styles.metricsBox}>
      {liftsOpen && (<MetricListItem title={t('resort.skiReport.liftOpen')} Icon={SvgLifts} metric={liftsOpen} />)}
      {acresOpen && (
      <MetricListItem title={t('resort.skiReport.acresOpen')} Icon={SvgAcres} metric={acresOpen} />)}
      {kmsOpen && (
      <MetricListItem title={t('resort.skiReport.kmOpen')} Icon={SvgAcres} metric={kmsOpen} />)}

      {runsOpen && (
      <MetricListItem title={t('resort.skiReport.runsOpen')} Icon={SvgRuns} metric={runsOpen} />)}

      {terrainDetails && (
      <div className={styles.items}>
        {terrainDetails.map((terainDetail: IResortTerrainDetail) => (
          <MetricListItem
            key={terainDetail.title}
            title={terainDetail.title}
            Icon={terainDetail.icon}
            metric={terainDetail.value}
            className={terainDetail.className}
          />
        ))}
      </div>
      )}

      {!!fullResort.terrain?.nordic?.open && (
      <MetricListItem
        key="nordicOpen"
        title={t('resort.skiReport.nordicOpen')}
        Icon={SvgOpenTotal}
        metric={unitT(fullResort.terrain?.nordic?.open)}
      />
      )}

      {!!fullResort.terrain?.nordic?.skategroomed && (
      <MetricListItem
        key="skateGroomed"
        title={t('resort.skiReport.nordicSkategroomed')}
        Icon={SvgSkateGroomed}
        metric={unitT(fullResort.terrain?.nordic?.skategroomed)}
      />
      )}

      {!!fullResort.terrain?.nordic?.trackset && (
      <MetricListItem
        key="trackset"
        title={t('resort.skiReport.nordicTrackset')}
        Icon={SvgTrackset}
        metric={unitT(fullResort.terrain?.nordic?.trackset)}
      />
      )}
    </div>
  );
};
